import { useState } from 'react';
import useMerchantPortalAxios, { useMerchantPortalFormData } from "../utils/axios";
import { useDispatch } from "react-redux";
import { setCashAdvanceDesign, setCashAdvanceDetails, setPayrollPageActiveButton, setReduxPayrollAdvanceList, setShowCashAdvanceDetails, setShowConfirmationButton } from '../features/AdvancePayrollConfirmPopupSlice';
import { setRequestData } from '../features/transactionDetailsSlice';

function PayrollAdvanceApi() {

    const [payrollCashAdvanceTemplate, setPayrollCashAdvanceTemplate] = useState([]);
    const [payrollAdvanceList, setPayrollAdvanceList] = useState(null);
    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxios1 = useMerchantPortalFormData();
    const CustomMerchantPortalClient = MerchantPortalAxios;
    CustomMerchantPortalClient.defaults.timeout = 600000;
    const CustomMerchantPortalClient1 = MerchantPortalAxios1;
    CustomMerchantPortalClient1.defaults.timeout = 600000;

    const dispatch = useDispatch();

    const GetCashAdvanceTemplate = async () => {
        const res = await MerchantPortalAxios.get('/v1/PayrollAdvance/GetCashAdvanceTemplate');
        if (res) {
            setPayrollCashAdvanceTemplate(res.data);
        }
    }
    const GetCashAdvanceDesign = async () => {
        try {
            const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/GetCashAdvanceDesign', {
                SessionID: sessionStorage.getItem("SessionID"),
            });
            if (response) {
                dispatch(setCashAdvanceDesign(response?.data?.Payload?.UploadInterface));
                return response?.data?.Payload?.UploadInterface;
            }
        } catch (error) {
            console.error("Error fetching cash advance design", error);
        }

    }

    const UploadPayrollAdvanceList = async (payload) => {
        if (payload.formFile) {
            const fileData = payload.formFile.split(',')[1];
            const mimeType = payload.formFile.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            payload.formFile = new File([byteArrays], payload?.ReasonFileName, { type: mimeType });
        }
        const { ReasonFileName, ...newPayload } = payload
        const response = await CustomMerchantPortalClient1.post('/v1/PayrollAdvance/UploadPayrollAdvanceList', newPayload);
        return response.data;
    }

    const ReplacePayrollAdvanceList = async (payload) => {
        if (payload.formFile) {
            const fileData = payload.formFile.split(',')[1];
            const mimeType = payload.formFile.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            payload.formFile = new File([byteArrays], payload.ReasonFileName, { type: mimeType });
        }
        const { ReasonFileName, ...newPayload } = payload
        const response = await CustomMerchantPortalClient1.post('/v1/PayrollAdvance/ReplacePayrollAdvanceList', newPayload);
        return response.data;
    }

    const GetPayrollAdvanceList = async (IsFromPayroll = false) => {
        try {
            const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/GetPayrollAdvanceList', {
                SessionID: sessionStorage.getItem('SessionID'),
                IsFromPayroll
            });
            if (response && response.data) {

                var result = {
                    list: response.data.Payload.corporatePayrollAdvances,
                    totals: {
                        totalEmployees: response.data.Payload.TotalEmployees,
                        totalEligible: response.data.Payload.TotalEligible,
                        totalAmountDisbursed: response.data.Payload.TotalAmountDisbursed,
                        totalEmployeesWithCashAdvance: response.data.Payload.TotalEmployeesWithCashAdvance,
                        totalDisabled: response.data.Payload.TotalDisabled,
                    }
                }

                setPayrollAdvanceList(response.data.Payload.corporatePayrollAdvances);
                dispatch(setShowConfirmationButton(response.data.Payload.ShowConfirmationPopUp));
                dispatch(setReduxPayrollAdvanceList(result))

                return result;
            }
        } catch (error) {
            console.error('Error fetching payroll advance list:', error);
            throw error;
        }
    }


    const EditUserPayrollAdvance = async (payload) => {
        try {
            const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/EditUserPayrollAdvance', payload, {
                headers: {
                    'Content-Type': 'application/json-patch+json'
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error editing user payroll advance:", error);
            throw error;
        }
    }

    const PushPayrollAdvanceList = async (payload) => {
        const res = await MerchantPortalAxios.post(
            "/v1/PayrollAdvance/PushPayrollAdvanceList",
            payload
        );
        // await GetCashAdvanceDesign();
        await GetPayrollAdvanceList();
        setPayrollAdvanceList(res.data.Payload);

        

        return res.data;
    };


    const ConfirmEligibleEmployees = async (payload) => {
        const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/ConfirmEligibleEmployees', payload)
        return response.data.Payload;
    }

    const DisableAllPayrollAdvance = async () => {
        const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/DisableAllPayrollAdvance', {
            SessionID: sessionStorage.getItem('SessionID')
        })
        return response.data;
    }

    const ToStatusUserPayrollAdvance = async (payload) => {
        try {
            const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/ToStatusUserPayrollAdvance', payload, {
                headers: {
                    "Content-Type": "application/json-patch+json",
                    Authorization: sessionStorage.getItem("Token"),
                }
            });

            return response.data;
        } catch (error) {
            console.error("Error editing user payroll advance:", error);
            throw error;
        }
    }

    const DeleteUserPayrollAdvance = async (payload) => {
        try {
            const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/DeleteUserPayrollAdvance', payload, {
                headers: {
                    "Content-Type": "application/json-patch+json",
                    Authorization: sessionStorage.getItem("Token"),
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error deleting user payroll advance:", error);
            throw error;
        }
    }


    const GetPayrollAdvanceSummary = async (checkerAdvanceID) => {

        const payload = {
            SessionID: sessionStorage.getItem("SessionID"),
            CheckerAdvanceId: checkerAdvanceID
        }

        try {
            const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/GetPendingAdvanceDetails', payload);
            dispatch(setShowCashAdvanceDetails(true));
            dispatch(setCashAdvanceDetails(response.data.Payload.payrollAdvanceDetailsList));
            dispatch(setRequestData({field: "visible", value: false}));
        }
        catch (error) {
            console.error("Error fetching payroll advance summary", error);
            throw error;
        }
    }

    const ApproveRejectPayrollAdvance = async (payload) => {
        const response = await MerchantPortalAxios.post('/v1/PayrollAdvance/ApproveRejectPendingAdvanceDetails', payload);
        return response.data.Payload;
    }

    return ({
        GetCashAdvanceTemplate,
        payrollCashAdvanceTemplate,
        GetCashAdvanceDesign,
        UploadPayrollAdvanceList,
        GetPayrollAdvanceList,
        payrollAdvanceList,
        EditUserPayrollAdvance,
        ConfirmEligibleEmployees,
        DisableAllPayrollAdvance,
        ToStatusUserPayrollAdvance,
        PushPayrollAdvanceList,
        payrollAdvanceList,
        DeleteUserPayrollAdvance,
        ReplacePayrollAdvanceList,
        GetPayrollAdvanceSummary,
        ApproveRejectPayrollAdvance
    });
}

export default PayrollAdvanceApi;